const React = require("react");
const {View} = require("@react-pdf/renderer");

const styles = require("../../styles/");

const SectionSubtitle = require("../SectionSubtitle/");
const SectionItem = require("../SectionItem/");

module.exports = ({subtitle, items = [], additionalStyles, withBorder}) => (
  <View style={{
    ...styles.section,
    ...(withBorder ? styles.sectionBorder : {}),
    ...additionalStyles
  }}>
    {subtitle && (
      <View>
        <SectionSubtitle text={subtitle} />
      </View>
    )}
    <View style={styles.sectionRow}>
      {items.map((el, id) => (
        <View key={id} style={styles.sectionCol}>
          <SectionItem {...el} />
        </View>
      ))}
    </View>
  </View>
);
